
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-fa02001e&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./PageHeader.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./PageHeader.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-fa02001e!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./PageHeader.vue"),
  /* scopeId */
  "data-v-fa02001e",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/helpers/PageHeader.vue
// module id = 37
// module chunks = 1